export const ActionTypes = {
    SET_DATA: "app/redux/table/SET_DATA",
    SET_FILTER_DATA: "app/redux/table/SET_FILTER_DATA",
    EDIT_DATA_BY_ID: "app/redux/table/EDIT_DATA_BY_ID",

    SET_DATA2: "app/redux/table/SET_DATA2",
    SET_FILTER_DATA2: "app/redux/table/SET_FILTER_DATA2",
}